export default __webpack_public_path__ + "static/media/premium_card_2@3x.2a8a1d25.png";